import { ultraWideModalStyles } from '@/components/Elements/Modal/customStyles';
import { PaymentsModal } from '@/components/Elements/PaymentsModal';
import { ProductTypes } from '@/types';

import {
  PhoneValidationContainer,
  PhoneValidationContainerProps,
} from './PhoneValidationContainer';

export interface iPhoneValidationContainerInModalProps
  extends Omit<PhoneValidationContainerProps, 'onRequestInfo'> {
  isOpen: boolean;
  shouldCloseOnOverlayClick?: boolean;
  onRequestClose: () => void;
  onRequestInfo: (product: ProductTypes | null) => void;
  product?: ProductTypes | null;
}

export const PhoneValidationContainerInModal = ({
  isOpen,
  shouldCloseOnOverlayClick,
  onRequestClose,
  onRequestInfo,
  mobileToken,
  userData,
  product = null,
  onSubmitFormPhoneValidation,
  onSubmitFormTokenCheck,
}: iPhoneValidationContainerInModalProps) => {
  const onDefaultRequestClose = () => {
    onRequestClose && onRequestClose();
  };

  const onDefaultRequestInfoOpen = () => {
    onRequestInfo && onRequestInfo(product);
  };

  return (
    <PaymentsModal
      isOpen={isOpen}
      style={ultraWideModalStyles}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onRequestClose={onDefaultRequestClose}
    >
      <PhoneValidationContainer
        className="pr-5 overflow-y-auto max-h-[75vh]"
        mobileToken={mobileToken}
        userData={userData}
        onRequestInfo={onDefaultRequestInfoOpen}
        onSubmitFormPhoneValidation={onSubmitFormPhoneValidation}
        onSubmitFormTokenCheck={onSubmitFormTokenCheck}
        showFooter={true}
      />
    </PaymentsModal>
  );
};
